import React from 'react';

const mapVideosSection = (response, mediaPath, verticalName) => {
  let videos = [];
  const videoData = response.video_sections;
  if (verticalName === 'Landcraft' && videoData.length === 0) {
    const result = {
      title: 'Tangled Up In Green',
      description: '<p></p>\r\n',
      mobile_description: '<p></p>\r\n',
      videos: [
        {
          id: new Date().getTime(),
          description: '<p></p>\r\n',
          link: 'https://vimeo.com/910308029?share=copy',
          title: 'Project Walk-through',
          vertical_video_section_id:
            new Date().getTime() + Math.floor(Math.random() * 100),
          thumbnail: '',
          thumbnail_url: '',
        },
      ],
      web: mediaPath.web,
      mobile: mediaPath.mobile,
      thumbnail: mediaPath.thumbnail,
    };
    videos.push(result);
  } else {
    videoData.map(video => {
      const result = {
        title: video.title,
        description: video.description,
        mobile_description: video.mobile_description,
        videos: video.vertical_videos, // TODO: change variable names
        web: mediaPath.web,
        mobile: mediaPath.mobile,
        thumbnail: mediaPath.thumbnail,
      };
      videos.push(result);
    });
  }
  return videos;
};

export const VideoMapper = {
  mapVideosSection,
};
